import React, { useState } from 'react'

const InternshipAppdev = () => {
    const [activeTab, setActiveTab] = useState('basics'); // Default tab

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <section id="devops">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="text-purple">6-Month App development Roadmap </h2>
                        <p className="fw-medium">(From Scratch to Expert)</p>
                    </div>
                </div>
                <div className="row my-5 devcontaint">
                    <div className="col-md-3 col-12">
                        <div className="left-side h-100 flex-md-row flex-column">
                            <ul className="d-md-block d-flex">
                                {/* Tab Buttons */}
                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'basics' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('basics')}
                                >
                                    <div className={`fs-1 image-section type2    ${activeTab === 'basics' ? '' : '  '}`}>
                                        1
                                    </div>
                                    <div className={`text-section d-md-inline ${activeTab === 'basics' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold" >Basics</h6>
                                    </div>
                                </li>

                                <li
                                    role='button' className={`d-flex flex-md-row flex-column ${activeTab === 'react' ? 'active ' : ''}`}
                                    onClick={() => handleTabClick('react')}
                                >
                                    <div className="image-section type2 fs-2">
                                        2
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'react' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Advanced UI and APIs</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'node-js' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('node-js')}
                                >
                                    <div className="image-section type2 fs-1">
                                        3
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'node-js' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Advanced Features
                                        </h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'MongoDB' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('MongoDB')}
                                >
                                    <div className="image-section type2 fs-1">
                                        4
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'MongoDB' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Architecture and Optimization</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'full-stack' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('full-stack')}
                                >
                                    <div className="image-section type2 fs-1 ">
                                        5
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'full-stack' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Real-World Project</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'interview-preparation' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('interview-preparation')}
                                >
                                    <div className="image-section type2 fs-1" >
                                        6
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'interview-preparation' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Interview preparations</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-9 col-12">
                        <div className="right-side">
                            {activeTab === 'basics' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Android Basics</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 1: Introduction to Android</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 1: Overview of Android – </strong> History, Versions, Features.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 2: Setting up Android Studio and Emulator – </strong> Install and configure development tools.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 3: Understanding Project Structure – </strong> Gradle, Manifest, Resources.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 4: Creating Your First App – </strong> Build a "Hello World" application.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 5: Test Day – </strong> Quiz on Android Basics and Setup.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 2: Activity and Lifecycle</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 6: Activity Lifecycle Overview – </strong> Understand activity states and transitions.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 7: Intents – </strong> Explicit and Implicit Navigation.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 8: Fragments and Fragment Lifecycle – </strong> Learn fragment basics and lifecycle methods.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 9: Exploring Layouts – </strong> LinearLayout, ConstraintLayout, and their use cases.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 10: Test Day – </strong> Activity and Lifecycle Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 3: Resources and Localization</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 11: Strings, Colors, and Dimensions Basics – </strong> Manage and define resource values.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 12: Adding Drawable Resources – </strong> Work with images and custom shapes.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 13: Localization Basics – </strong> Implement support for multiple languages.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 14: Styles and Themes Introduction – </strong> Customize app appearance.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 15: Test Day – </strong> Quiz on Resources and Localization.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 4: Data Storage Basics</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 16: SharedPreferences – </strong> Saving Key-Value Pairs for user data.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 17: File Storage Basics – </strong> Writing and reading files.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 18: SQLite Database Introduction – </strong> Basics of using SQLite in Android.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 19: Simple CRUD Operations in SQLite – </strong> Create, Read, Update, and Delete data.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 20: Test Day – </strong> Data Storage Basics Quiz.
                                        </li>
                                    </ul>
                                </div>

                            )}
                            {activeTab === 'react' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Advanced UI and APIs</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 5: RecyclerView and Adapters</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 21: Introduction to RecyclerView – </strong> Learn the basics of RecyclerView for displaying lists.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 22: Setting Up RecyclerView Adapters – </strong> Create and bind data to adapters.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 23: CardView for Enhanced UI – </strong> Use CardView for a polished and modern UI design.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 24: ViewPager for Swiping – </strong> Implement swipeable views with ViewPager.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 25: Test Day – </strong> Quiz on RecyclerView and Adapters.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 6: Networking Basics</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 26: Understanding REST APIs and JSON – </strong> Basics of APIs and data formats.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 27: Introduction to Retrofit Library – </strong> Learn the fundamentals of the Retrofit library.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 28: Making API Calls Using Retrofit – </strong> Fetch data from a remote API.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 29: Parsing JSON Responses – </strong> Process and display data from JSON responses.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 30: Test Day – </strong> Networking Basics Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 7: Navigation and Material Design</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 31: Navigation Component Basics – </strong> Overview of Android's Navigation Component.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 32: Setting Up Navigation Graph – </strong> Define navigation paths in your app.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 33: Exploring Material Design – </strong> Use Floating Action Button (FAB) and SnackBar.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 34: Bottom Navigation and Tabs – </strong> Implement bottom navigation and tab layouts.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 35: Test Day – </strong> Navigation and Material Design Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 8: Multi-Threading and Background Work</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 36: Introduction to Threads and Handlers – </strong> Basics of threading in Android.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 37: AsyncTask Overview – </strong> Perform background tasks with AsyncTask.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 38: WorkManager Basics – </strong> Learn how to manage background tasks efficiently.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 39: Practical – </strong> Background tasks implementation using WorkManager.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 40: Test Day – </strong> Quiz on Multi-Threading and Background Work.
                                        </li>
                                    </ul>
                                </div>



                            )}
                            {activeTab === 'node-js' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Advanced Features</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 9: Room Database Basics</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 41: Introduction to Room Database – </strong> Learn about Room Database and its features for data persistence.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 42: CRUD Operations with Room – </strong> Implement Create, Read, Update, and Delete operations using Room.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 43: Relationships in Room (One-to-Many) – </strong> Manage relational data with one-to-many relationships.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 44: Using LiveData with Room – </strong> Integrate LiveData for observing database changes in real time.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 45: Test Day – </strong> Room Database Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 10: Notifications and Sensors</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 46: Introduction to Firebase Cloud Messaging – </strong> Learn how to send push notifications using Firebase.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 47: Local Notifications – </strong> Create and manage notifications on the device.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 48: Basics of Sensors (Accelerometer) – </strong> Explore the use of device sensors, starting with the accelerometer.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 49: Fetching GPS Location – </strong> Implement GPS functionality to retrieve location data.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 50: Test Day – </strong> Quiz on Notifications and Sensors.
                                        </li>
                                    </ul>
                                </div>
                            )}



                            {activeTab === 'MongoDB' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Architecture and Optimization</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 11: App Architecture</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 51: Introduction to MVVM Architecture – </strong> Learn the Model-View-ViewModel architecture and its benefits.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 52: ViewModel and LiveData Basics – </strong> Explore how ViewModel and LiveData simplify data handling.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 53: Repositories for Data Handling – </strong> Implement repositories for better data management.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 54: Implementing Dependency Injection (Hilt) – </strong> Set up and use Hilt for dependency injection in Android apps.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 55: Test Day – </strong> Architecture Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 12: Animations and Performance</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 56: Animations: Property Animations and Transitions – </strong> Create smooth and dynamic animations in your app.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 57: Using MotionLayout – </strong> Learn to design complex animations using MotionLayout.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 58: UI Optimization Tips and Tools – </strong> Optimize UI performance using best practices and tools.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 59: Refactoring for Performance – </strong> Refactor code to enhance app performance and responsiveness.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 60: Test Day – </strong> Quiz on Animations and Optimization.
                                        </li>
                                    </ul>
                                </div>


                            )}

                            {activeTab === 'full-stack' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Real-World Project</h1>
                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 13-14: E-Commerce App (Part 1)</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 61-62: Define Scope and Set Up Project Architecture – </strong> Plan the e-commerce app scope and establish a solid project structure.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 63-64: Authentication and User Management – </strong> Implement user login, registration, and account management features.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 65-66: Product Listing with API Integration – </strong> Fetch and display product data from an API.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 67-68: Search and Filter Features – </strong> Add functionality for searching and filtering products.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 69-70: Test Day – </strong> Mid-project evaluation to review progress and functionality.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 15: E-Commerce App (Part 2)</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 71-72: Add Cart and Order Features – </strong> Implement a shopping cart and order placement functionality.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 73: Integrate Payment Gateway – </strong> Set up a payment system for order transactions.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 74: Notifications for Orders – </strong> Add notifications to inform users about their order status.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 75: Finalize UI and Debugging – </strong> Polish the user interface and debug the app to ensure functionality.
                                        </li>
                                    </ul>
                                </div>
                            )}

                            {activeTab === 'interview-preparation' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Interview Preparation and Certification</h1>
                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 16: Interview Preparation</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 76: Android Interview Basics (Core Concepts) – </strong> Review essential Android concepts for interviews.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 77: Problem-Solving Practice – </strong> Work on Android-specific problem-solving exercises.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 78: Mock Technical Interviews – </strong> Simulate real technical interviews to build confidence.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 79: Resume and LinkedIn Optimization – </strong> Update your resume and LinkedIn profile for Android development roles.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 80: Test Day – </strong> Participate in mock technical and HR interviews.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 17: Certification Prep and Final Review</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 81-82: Review Core Topics for Certification – </strong> Revisit key Android development topics for certification.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 83: Mock Test for Certification – </strong> Take a practice test to gauge certification readiness.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 84: Final Project Review – </strong> Ensure your project is polished and aligns with industry standards.
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 85: Certifications and Job Applications – </strong> Apply for Android certifications and start job applications.
                                        </li>
                                    </ul>
                                </div>


                            )}
                        </div>
                    </div>
                </div>


            </div >
        </section >
    )
}

export default InternshipAppdev